export default __webpack_public_path__ + "static/media/promo-harry-in-hiding_02.049ca7fb.jpg";